import * as React from "react";
import { singleton } from "logic/singleton";
const ColorSchemeContext = React.createContext(void 0);
export default singleton("contexts.ColorSchemeContext", () => ColorSchemeContext);
